import { Controller } from "@hotwired/stimulus"

// Sums the durations of every <audio> inside its scope and renders a running
// total. Durations arrive asynchronously (preload="metadata"), so we recompute
// as each one resolves and drop the "…" once they are all in.
export default class extends Controller {
  static targets = ["output"]

  connect() {
    this.audios = Array.from(this.element.querySelectorAll("audio"))
    this.resolved = new Set()
    this.handlers = new Map()

    this.audios.forEach((audio) => {
      const handler = () => {
        this.resolved.add(audio)
        this.render()
      }
      this.handlers.set(audio, handler)
      audio.addEventListener("loadedmetadata", handler)
      audio.addEventListener("error", handler)
      if (audio.readyState >= HTMLMediaElement.HAVE_METADATA) this.resolved.add(audio)
    })

    this.render()
  }

  disconnect() {
    this.handlers.forEach((handler, audio) => {
      audio.removeEventListener("loadedmetadata", handler)
      audio.removeEventListener("error", handler)
    })
  }

  render() {
    if (!this.hasOutputTarget) return

    const total = this.audios.reduce((sum, audio) => {
      return Number.isFinite(audio.duration) ? sum + audio.duration : sum
    }, 0)

    const complete = this.resolved.size >= this.audios.length
    this.outputTarget.textContent = this.format(total) + (complete ? "" : " …")
  }

  format(seconds) {
    const total = Math.round(seconds)
    const mins = Math.floor(total / 60)
    const secs = String(total % 60).padStart(2, "0")
    return `${mins}:${secs}`
  }
}
